import { ColumnControlContextProvider } from '@/context/columnControlContext';
import { RELATIONSHIP_COMPANY_CONTACT_DEFAULT_HIDDEN_COLUMNS } from '@/utils/relationshipContactTableSync';
import RelationshipCompanyContactsTableContent from './RelationshipCompanyContactsTableContent';

export const RelationshipCompanyContactsTable = () => (
	<ColumnControlContextProvider
		variant='relationshipCompanyContacts'
		value='relationshipCompany'
		defaultHiddenColumns={RELATIONSHIP_COMPANY_CONTACT_DEFAULT_HIDDEN_COLUMNS}
	>
		<RelationshipCompanyContactsTableContent />
	</ColumnControlContextProvider>
);

RelationshipCompanyContactsTable.displayName = 'RelationshipCompanyContactsTable';

export default RelationshipCompanyContactsTable;
